<template>
  <div class="experience-content-container">
    <div class="experience-card-container">
      <div class="experience-card-wrapper one wow fadeInUp">
        <div class="card-left">
          <img src="@/assets/images/experience-pic1.png" alt="" />
        </div>
        <div class="card-right">
          <div class="right-content-container">
            <div class="logo wow fadeInRight" data-wow-delay="0.1s">
              <img src="@/assets/images/zn-logo.png" alt="" />
            </div>
            <div class="name wow fadeInRight" data-wow-delay="0.2s">
              <span>众诺CRM</span>
            </div>
            <div class="desc wow fadeInRight" data-wow-delay="0.3s">
              <span
                >专为妇产医院快速销售而打造的客户关系管理系统，全流程解决客户管理需求</span
              >
            </div>
          </div>

          <div class="btn-container">
            <div class="experience-btn wave wow fadeInRight" data-wow-delay="0.4s">
              <span>获取体验资格</span>
            </div>
          </div>
        </div>
      </div>
      <div class="experience-card-wrapper two wow fadeInUp">
        <div class="card-left">
          <img src="@/assets/images/experience-pic2.png" alt="" />
        </div>
        <div class="card-right">
          <div class="right-content-container">
            <div class="logo wow fadeInRight" data-wow-delay="0.1s">
              <img src="@/assets/images/mly-logo.png" alt="" />
            </div>
            <div class="name wow fadeInRight" data-wow-delay="0.2s">
              <span>玛莉亚U+</span>
            </div>
            <div class="desc wow fadeInRight" data-wow-delay="0.3s">
              <span
                >妇产医疗服务销售一体化工具，依托于大流量平台，实现引流到变现的快速转化</span
              >
            </div>
          </div>

          <div class="btn-container">
            <div class="experience-btn wave wow fadeInRight" data-wow-delay="0.4s">
              <span>微信扫码体验</span>
            </div>
            <div class="code-btn wave wow fadeInRight" data-wow-delay="0.5s">
              <img src="@/assets/images/icon-code.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="experience-card-wrapper three wow fadeInUp">
        <div class="card-left">
          <img src="@/assets/images/experience-pic3.png" alt="" />
        </div>
        <div class="card-right">
          <div class="right-content-container">
            <div class="logo wow fadeInRight" data-wow-delay="0.1s">
              <img
                style="height: 30px"
                src="@/assets/images/ls-web-logo.png"
                alt=""
              />
            </div>
            <div class="name wow fadeInRight" data-wow-delay="0.2s">
              <img src="@/assets/images/icon-product.png" alt="" />
            </div>
            <div class="desc wow fadeInRight" data-wow-delay="0.3s">
              <span>定制您的软件系统解决方案</span>
            </div>
          </div>

          <div class="btn-container">
            <div class="experience-btn wave wow fadeInRight" data-wow-delay="0.4s">
              <span>软件定制服务</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.experience-content-container {
  padding: 80px 0;
  .experience-card-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    .experience-card-wrapper {
      margin-bottom: 20px;
      width: 1100px;
      height: 380px;
      // background: #F9FAFF;
      border: 1px solid #e9eef5;
      box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
      overflow: hidden;
      display: flex;
      .card-left {
        width: 750px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ffffff;
        border-right: 1px solid #e9eef5;
        box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
        img {
          height: 260px;
        }
      }
      .card-right {
        width: 350px;
        height: 380px;
        padding: 40px;
        background: #f9faff;
        // border-left: 1px solid #e9eef5;
        box-shadow: 0 2px 16px 0 rgba(71, 75, 82, 0.06);
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .right-content-container {
          .logo {
            margin-bottom: 30px;
            img {
              height: 40px;
            }
          }
          .name {
            margin-bottom: 20px;
            font-family: PingFangSC-Semibold;
            font-size: 24px;
            color: #222222;
            img {
              height: 20px;
            }
          }
          .desc {
            padding-top: 20px;
            border-top: 1px solid #eaecf2;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #7b8799;
            line-height: 28px;
          }
        }

        .btn-container {
          display: flex;
          .experience-btn {
            width: 136px;
            height: 34px;
            background-image: linear-gradient(270deg, #119dfd 0%, #0764fb 100%);
            border-radius: 17px;
            font-family: PingFangSC-Regular;
            font-size: 16px;
            color: #ffffff;
            @include btn;
          }
          .code-btn {
            margin-left: 10px;
            width: 34px;
            height: 34px;
            border-radius: 50%;
            background: #ffffff;
            border: 1px solid #e9eef5;
            @include btn;
            img {
              width: 20px;
              height: 20px;
            }
          }
        }
      }
    }
    .two {
      .card-left {
        img {
          height: 400px;
          transform: translateY(75px);
        }
      }
    }
    .three {
      .card-left {
        img {
          height: 350px;
          transform: translate(-273px, 113px);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/experience/components/experienceContent.vue